import { ref } from 'vue';

import { Pusher } from 'src/libs/pusher/index.js';
import { apiUrlV1, cancellableRequest } from 'src/services/api.js';

/**
 * @typedef {import('@habralab/pusher/dist/index').CareerPusherEventMap} CareerPusherEventMap
 */

async function JWTTokenGetter() {
  const response = await cancellableRequest({
    method: 'GET',
    url: `${apiUrlV1}/users/pusher_token`,
  });

  return response.data.token;
}

function getPusherURI() {
  const overloadedUri = localStorage.getItem('overloaded_pusher_uri');
  const isTestEnv = window.location.hostname !== 'career.habr.com';

  if (isTestEnv && overloadedUri) return overloadedUri;

  if (isTestEnv) return 'wss://rc.pusher.habratest.net/ws/career';

  return 'wss://pusher.habr.com:8443/ws/career';
}

/**
 * @type {Pusher<CareerPusherEventMap> | null}
 */
let pusher = null;

const isConnected = ref(false);

export function usePusher() {
  if (pusher || !window.app.isUserLoggedIn) return { pusher, isConnected };

  pusher = new Pusher({
    uri: getPusherURI(),
    JWTTokenGetter,
  });

  pusher.on('connected', (connected) => {
    isConnected.value = connected;
  });

  pusher.connect();

  return {
    pusher,
    isConnected,
  };
}
